var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIconEmailLineGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7501 5.90001C21.7501 4.855 20.8951 4 19.8501 4H4.65001C3.605 4 2.75 4.855 2.75 5.90001V17.3C2.75 18.345 3.605 19.2001 4.65001 19.2001H19.8501C20.8951 19.2001 21.7501 18.345 21.7501 17.3V5.90001ZM19.8501 5.90001L12.25 10.65L4.65001 5.90001H19.8501ZM19.8501 17.3H4.65001V7.80001L12.25 12.55L19.8501 7.80001V17.3Z",
    fill: "#54BD95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIconEmailLineGreen);
export default __webpack_public_path__ + "static/media/login_icon_email_line_green.1766aecae7355eafeae40ca669fa7c3e.svg";
export { ForwardRef as ReactComponent };